import { Icon, message, Upload, Button, Row, Col, Checkbox, Form, AutoComplete } from 'antd';
import React from 'react';
import { invoiceImport, invoiceInput } from 'src/api';
import { JSString } from 'kts-scaffold-framework/utils/kit';
import debounce from 'lodash/debounce';
import { create } from './BaseImport';
const FormItem = Form.Item;
const Option = AutoComplete.Option;
@create()
class Component extends React.Component<any, any>{
    private upload: any;
    private list = [];
    constructor(props: any) {
        super(props);
        this.state = {
            callback: null,
            keyPrefix: null,
            token: null,
            uploadUrl: null,
            loop: null,
            fileList: [],
            url: this.props.url && this.props.url.qrtoken,
            fileName: null,
            groupNumber: null,
            showFive: this.props.url.show || false,
            list: [],
            draftFlag: 1,
            showdeduction: this.props.url.deduction || false,
            inputType: this.props.url.imageinputType,
        };
        this.fetchGroup = debounce(this.fetchGroup, 800);
    }
    //token之所以使用异步是因为指定发票组的号码
    getToken = async (filename: string) => {
        const { url, draftFlag, inputType } = this.state;
        const groupNumber = this.props.form.getFieldValue('groupNumber');
        const data = { url, groupNumber, draftFlag, inputType, orgFileName: filename };
        if (typeof data.url === 'function') {
            data.url(data);
        } else {
            const response = await invoiceImport.imageImport(null, data);
            const err = response.er;
            const res = response.res;
            if (err) {
                return false;
            }
            if (res) {
                this.setState({
                    keyPrefix: res.keyPrefix,
                    token: res.token,
                    uploadUrl: res.uploadUrl,
                });
                return true;
            } else {
                return false;
            }
        }
    }
    callback = () => {
        if (this.props.fnForceUpdate) {
            this.props.fnForceUpdate();
        }
    }
    onAddGroup = () => {
        invoiceInput.CreatGroup(this, {}).then((response: any) => {
            const err2 = response.er;
            const res = response.res;
            if (err2) {
                return null;
            } else {
                if (res) {
                    message.success('操作成功');
                    this.props.form.setFieldsValue({ groupNumber: res });
                }
            }
        });
    }
    onGroupName = (e) => {
        this.setState({
            groupNumber: e.target.value
        });
    }
    fetchGroup = (value) => {
        const groupNumber = value;
        if (groupNumber) {
            invoiceInput.GetGroupList(this, { groupNumber }).then((response: any) => {
                const err = response.er;
                const res = response.res;
                if (err) {
                    return null;
                } else {
                    if (res) {
                        this.setState({
                            list: res
                        });
                    }
                }
            });
        }
    }
    ondraftChange = (e) => {
        if (e.target.checked) {
            this.setState({
                draftFlag: 1
            });
        } else {
            this.setState({
                draftFlag: 0
            });
        }
    }
    render() {
        let { keyPrefix, token, uploadUrl, fileName } = this.state;
        let formItemLayout = {
            labelCol: { span: 8 },
            wrapperCol: { span: 16 },
        };

        const { getFieldDecorator } = this.props.form;
        const options = this.state.list.map(d => <Option key={d.groupNumber}>{d.groupNumber}</Option>);
        const props = {
            name: 'file',
            multiple: true,
            data: { key: keyPrefix + JSString.randomABC(8) + fileName, token: token },
            action: '//' + uploadUrl,
            fileList: this.state.fileList,
            showUploadList: { showPreviewIcon: true, showRemoveIcon: false },
            onChange: (info) => {
                const status = info.file.status;
                let fileList = info.fileList;
                let allArr = [];
                let flag = true;
                for (var i = 0; i < fileList.length; i++) {
                    for (var j = 0; j < allArr.length; j++) {
                        if (fileList[i].uid === allArr[j].uid || !fileList[i].uid) {
                            flag = false;
                        }
                    }
                    if (flag) {
                        allArr.push(fileList[i]);
                    }
                }
                fileList = allArr;
                this.setState({ fileList });
                this.upload.props.data.key = keyPrefix + JSString.randomABC(8) + info.file.name;
                if (status === 'done') {
                    if (info.file.response.ok === false) {
                        info.file.status = 'error';
                        info.file.response = info.file.response.status.description || '系统错误';
                    } else {
                        message.success(
                            `${info.file.name} 文件上传成功`
                        );
                        window.setTimeout(() => { this.callback(); }, 2000);
                    }
                } else if (status === 'error') {
                    message.error(`${info.file.name} 文件上传失败.`);
                }
            },
            beforeUpload: (file, filelist) => {
                let filename = file.name;
                let typeName = filename.split('.')[(filename.split('.').length - 1)].toLowerCase(); 
                const isJPG = (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'application/pdf' || file.type === 'image/png' || file.type === 'image/bmp' || typeName === 'ofd');
                if (!isJPG) {
                    // message.error('仅支持bmp、jpg、jpeg、png、pdf格式');
                    file.status = 'error';
                    file.response = '不支持的文件格式。';
                    return isJPG;
                }
                if (/\s/g.test(file.name)) {
                    file.status = 'error';
                    file.response = '文件名不能有空格';

                    return false;
                }
                let isLt3M = file.size / 1024 / 1024 < 3;
                if (!isLt3M) {
                    // message.error('文件必须小于3MB!');
                    file.status = 'error';
                    file.response = '超过允许上传的文件大小限制。';

                    return isLt3M;
                }
                let filePiece = filename.split('.');
                // this.setState({
                //     fileName: '.' + filePiece[1]
                // });
                const { url } = this.state;
                const data = { url };

                if (typeof data.url === 'function') {
                    file.status = "loading";
                    data.url(file).then((res) => {
                        if (res) {
                            file.status = "done";
                        } else {
                            file.status = "error";
                        }
                        this.list.push(file);
                        this.setState({
                            fileList: this.list
                        });
                    });
                    return false;
                } else {
                    return new Promise((resolve, reject) => {
                        this.getToken(filename).then((res) => {
                            if (res) {
                                this.setState({
                                    fileName: '.' + filePiece[1]
                                });
                                resolve(file);
                            } else {
                                reject();
                            }
                        });
                    });
                }
            }
        };

        const Upload2 = Upload as any;

        return (
            <div>
                <Upload2
                    {...props}
                    className="imageupload"
                    ref={(upload) => { this.upload = upload; }}
                    accept=".jpg,.jpeg,.bmp,.png,.pdf,.ofd"
                >
                    <Button>
                        影像上传
                    </Button>
                    {
                        this.state.showdeduction ?
                            <p className={'notepostion notesword'}>仅支持bmp、jpg、jpeg、png、ofd格式，且单个文件不超过3MB</p> :
                            <p className={'notepostion notesword'}>仅支持bmp、jpg、jpeg、png、ofd、pdf格式，且单个文件不超过3MB</p>
                    }

                </Upload2>
                {
                    this.state.showFive &&
                    <Form >
                        <Row style={{ marginTop: 20 }}>
                            <Col span={21} >
                                <FormItem {...formItemLayout} label="指定到发票组">
                                    {getFieldDecorator('groupNumber', {
                                        rules: [{ message: '请输入编号(最大长度36位)', max: 36 }]
                                    })(
                                        <AutoComplete
                                            onSearch={this.fetchGroup}
                                        >
                                            {options}
                                        </AutoComplete>
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={2} offset={1}>
                                <span style={{ lineHeight: '39px' }} className="hand" onClick={this.onAddGroup}><Icon type="plus" /></span>
                            </Col>
                        </Row>
                    </Form>
                }
                {
                    this.state.showdeduction &&
                    <Row>
                        <FormItem {...formItemLayout} >
                            {getFieldDecorator('draftFlag', {
                                valuePropName: 'checked',
                                initialValue: !!this.state.draftFlag
                            })(
                                <Checkbox onChange={this.ondraftChange} >录入时勾选发票</Checkbox>
                            )}
                        </FormItem>
                    </Row>
                }
            </div>
        );
    }
}
export default Component;



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/display/part/InvoiceImport/InvoiceTab/ImageImport.tsx